import { http } from "../services/apiSecurity/Http.interceptor";
import { AccessFunctionality } from "./interface/AccessFunctionality";
import { Group } from "./interface/Group";

const URL: string = '/acessoFuncionalidades';

export const getAccessFunctionality = (groupsAd: Group) => {
    return http.post<AccessFunctionality[]>(URL, groupsAd);
}